import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import useStyles from './style';
import Typography from '../../../../atoms/Typography';
import get from 'lodash/get';

const Ranking = ({ question, response, onChange }) => {
  const classes = useStyles();
  const questionId = get(question, 'questionId', null);
  const questionOptions = get(question, 'options', []) || [];

  useEffect(() => {
    onChange(questionId, get(question, 'options', []) || []);
  }, []);

  const handleDragEnd = (result) => {
    if (!result?.destination) return;
    const reordered = Array.from(response || questionOptions);
    const [removed] = reordered.splice(get(result, 'source.index', 0), 1);
    reordered.splice(get(result, 'destination.index', 0), 0, removed);
    onChange(questionId, reordered);
  };

  return (
    <Box className={classes.root}>
      <Typography className={classes.questionLabel}>{question?.questionText || ''}</Typography>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId={questionId}>
          {(provided) => (
            <ol
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="rankingList"
            >
              {(response || questionOptions).map((opt, index) => (
                <Draggable key={opt} draggableId={opt} index={index}>
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      {opt}
                    </li>
                  )}
                </Draggable>
              ))}
              {provided?.placeholder}
            </ol>
          )}
        </Droppable>
      </DragDropContext>
    </Box>
  );
}

export default Ranking
